import React from "react"
import { Link } from "gatsby"

const SexyBtn = ({ text, to, color, className }) => {
  return (
    <Link to={to} className={`hover:shadow-theme-white-button cursor:pointer transition-shadow duration-250 ease-linear ${className}`}>
      {text}
    </Link>
  )
}

export default SexyBtn